module.exports = __webpack_public_path__ + "static/media/2.ec768f56.png";